"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calendarData = void 0;
/** 表示順は imageId（01〜12）の昇順。8月以降と年始が同時表示のときは年始を12月の次に並べる */
exports.calendarData = [
    {
        imageId: '01',
        active: true,
        weekday: { mainText: '通常料金' },
        weekend: { mainText: '＋8,800円' },
    },
    {
        imageId: '02',
        active: true,
        weekday: { mainText: '通常料金' },
        weekend: { mainText: '＋8,800円' },
    },
    {
        imageId: '03',
        active: true,
        weekday: { mainText: '通常料金' },
        weekend: { mainText: '＋8,800円' },
    },
    {
        imageId: '04',
        active: true,
        weekday: { mainText: '通常料金' },
        weekend: { mainText: '＋8,800円' },
    },
    {
        imageId: '05',
        active: false,
        weekday: { mainText: '通常料金' },
        weekend: { mainText: '＋8,800円' },
    },
    {
        imageId: '06',
        active: false,
        weekday: { mainText: '通常料金' },
        weekend: { mainText: '＋8,800円' },
    },
    {
        imageId: '07',
        active: false,
        weekday: { mainText: '通常料金' },
        weekend: { mainText: '＋8,800円' },
    },
    {
        imageId: '08',
        active: false,
        weekday: { mainText: '通常料金' },
        weekend: { mainText: '＋8,800円' },
        closedDayExtras: [{ label: '夏季休業', dotColor: 'summer-closure' }],
    },
    {
        imageId: '09',
        active: false,
        weekday: { mainText: '通常料金' },
        weekend: { mainText: '＋8,800円' },
    },
    {
        imageId: '10',
        active: false,
        weekday: { mainText: '通常料金' },
        weekend: { mainText: '＋8,800円' },
    },
    {
        imageId: '11',
        active: true,
        weekday: { mainText: '通常料金' },
        weekend: { mainText: '＋11,000円' },
        extraDetail: {
            label: '大安・友引 平日',
            mainText: '＋5,500円',
            dotColor: 'white',
            dotHasBorder: true,
        },
    },
    {
        imageId: '12',
        active: true,
        weekday: { mainText: '通常料金' },
        weekend: { mainText: '＋8,800円' },
    },
];
